import React, { useEffect, useState } from "react";
import { Button, Form, Col, Row, Modal } from 'react-bootstrap';
import { useSelector } from "react-redux";
import axios from 'axios';
import Swal from 'sweetalert2';
import PayUForm from '../../Utils/PayUForm';
import { toast } from 'react-toastify';
import 'react-date-picker/dist/DatePicker.css';
import 'react-calendar/dist/Calendar.css';

function ADSL({ operatorCode }) {
  const currentUser = useSelector((state) => state.data);
  const [payuData, setPayuData] = useState(false);
  const handleSubmit = async (e) => {
    e.preventDefault();
    const { Subscriber, Amount, type, wallet_type } = e.target;
    try {
      let sendData = {
        service: "adsl",
        service_provider: operatorCode,
        msisdn: Subscriber.value,
        amount: Amount.value,
        type: type.value,
        wallet_type: wallet_type?.value,
      };
      const response = await axios.post("/recharge/services/pay", sendData);
      const { status, message, hashData, rechage_response: rd } = response.data;
      if (status) {
        if (hashData) {
          const payuData = {
            hash: hashData.hash,
            txnid: hashData.txId,
            amount: hashData.amount,
            firstname: currentUser.name,
            email: currentUser.email,
          };
          setPayuData(payuData);
        }
        else {
          let rechrgeMessage = "<table align='center'><tr><td>Subscriber</td><td>" + rd.subscriber_number + "</td></tr><tr><td>Amount</td><td>" + rd.amount + "</td></tr><tr><td>Receipt</td><td>" + rd.reciept + "</td></tr><tr><td colspan='100%'>" + rd.message + "</td></tr></table>"
          Swal.fire({
            title: 'Recharge Successful!',
            html: rechrgeMessage,
            icon: 'success',
            //confirmButtonText: 'OK'
          });
        }
      }
      else {
        toast(message);
      }
    } catch (error) {
      if (error?.response?.data?.message) {
        toast(error.response.data.message);
      }
    }
  };

  return (
    <>
      {
        payuData && (
          <PayUForm formData={payuData} autoSubmit={true} />
        )
      }
      <Form onSubmit={handleSubmit}>
        <div className="row">
          <>
            <div class="col-lg-12 col-md-12">
              <label>Landline Number</label>
              <input type="text" class="form-control" name="Subscriber" required />
            </div>
            <div class="col-lg-4 col-md-4">
              <label>Amount</label>
              <input type="number" class="form-control" name="Amount" required />
            </div>
            <div class="col-lg-4 col-md-4">
              <label>Type</label>
              <select class="form-control" name="type" required>
                <option value="">--Select--</option>
                <option value="u">Unlimited</option>
                <option value="v">Volume Based</option>
              </select>
            </div>
            <div class="col-lg-4 col-md-4">
              <label>Wallet Type</label>
              <select class="form-control" name="wallet_type" required>
                <option value="">--Select--</option>
                <option value="wallet">Wallet</option>
                <option value="remitance">Remitance</option>
                <option value="payu">Online payment(Payu)</option>
              </select>
            </div>
            <div class="col-lg-12 col-md-12">
              <input type="submit" className="search-btn btn btn-primary" value="Pay" />
            </div>
          </>
        </div>
      </Form>
    </>
  );
}

export default ADSL;
